import { PACKAGE_JSON } from '../../version';
export function getUuid1() {
    return PACKAGE_JSON.package
        .split('')
        .map(function (char) { return char.charCodeAt(0); })
        .reduce(function (acc, val) { return acc + val; }, 0);
}
export function getUuid2() {
    return parseInt(PACKAGE_JSON.version.replace(/[^0-9]/g, ''));
}
export function getBuild(buildType) {
    switch (buildType) {
        case 0:
            return 'node';
        case 1:
            return 'esnext';
        case 2:
            return 'umd';
        case 3:
            return 'umd-ie';
    }
}
export function getClientInformation() {
    var navigator = getNavigator();
    return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        version: PACKAGE_JSON.version,
        package: PACKAGE_JSON.package,
        build: getBuild(1),
        mobile: /Mobi/i.test(navigator.userAgent)
    };
}
export function getNavigator() {
    if (typeof (navigator) !== 'undefined') {
        return navigator;
    }
    if (typeof (process) !== 'undefined') {
        return {
            userAgent: "node.js/io.js, " + process.version,
            platform: process.platform + "_" + process.arch
        };
    }
    return { userAgent: 'unknown', platform: 'unknown' };
}
export function getBytesFromBuffer(buf) {
    var res = [];
    if (buf) {
        for (var i = 0; i < buf.length; i++) {
            res.push(buf.readInt8(i));
        }
    }
    return res;
}
//# sourceMappingURL=functions.js.map